// Shared helpers for turning raw WordPress REST posts into the shapes the
// homepage components render. Lifted out of HomePage so the hero carousel and
// the recent-posts grid share one copy.

const HERO_FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&h=600&fit=crop';
const CARD_FALLBACK_IMAGE =
  'https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=400&h=250&fit=crop';

// Decode HTML entities (&amp; &#8217; ...) using a detached textarea
export const decodeHTMLEntities = (text) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};

// Build a plain-text excerpt from rendered post content, dropping headings first
// so the excerpt starts with actual prose. Only appends an ellipsis when the
// text was long enough to truncate.
export const buildExcerpt = (contentHtml = '', maxLength) => {
  const text = decodeHTMLEntities(
    contentHtml
      .replace(/<h[1-6][^>]*>.*?<\/h[1-6]>/gi, '') // Remove heading tags and their content
      .replace(/<[^>]*>/g, '') // Remove remaining HTML tags
      .trim()
  );

  if (!maxLength || text.length <= maxLength) return text;
  return `${text.substring(0, maxLength).trimEnd()}...`;
};

// Format a post for the hero carousel
export const formatHeroPost = (post) => {
  if (!post) return null;

  const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;
  const author = post._embedded?.author?.[0]?.name || 'Unknown Author';
  const categories = post._embedded?.['wp:term']?.[0] || [];
  const readTime = Math.ceil(post.content.rendered.split(' ').length / 200);

  return {
    id: post.id,
    title: post.title.rendered,
    excerpt: buildExcerpt(post.content.rendered, 200),
    image: featuredImage || HERO_FALLBACK_IMAGE,
    date: post.date,
    author,
    categories,
    readTime: `${readTime} min read`,
    slug: post.slug
  };
};

// Format a post for the recent-posts grid card
export const formatCardPost = (post) => {
  const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;
  const categories = post._embedded?.['wp:term']?.[0] || [];

  return {
    id: post.id,
    title: post.title.rendered,
    excerpt: buildExcerpt(post.content.rendered, 100),
    image: featuredImage || CARD_FALLBACK_IMAGE,
    date: post.date,
    category: categories[0]?.name || 'Uncategorized',
    slug: post.slug
  };
};

export const formatCardPosts = (posts) => (posts || []).map(formatCardPost);
